// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"a616164b","109":"bc7d6fa2","353":"a40f80b9","384":"0f64c250","499":"bf16e9b8","787":"f2d25998","984":"fc25e144"}[chunkId] + ".chunk.js";
};